"use client";
import clsx from "clsx";
import { type ReactNode, useEffect, useRef, useState } from "react";
import useDevice from "@/hooks/useDevice";
import useHideOnScroll from "@/hooks/useHideOnScroll";
import styles from "./index.module.css";

type Props = {
  children: ReactNode;
  isCampaign?: boolean;
  isHomePage: boolean;
};

const NavbarWrap = ({ children, isHomePage }: Props) => {
  const headerHeight = 300;
  const [scrollPosition, setScrollPosition] = useState(0);
  const navbarRef = useRef(null);
  const { isHidden, isTop } = useHideOnScroll(isHomePage);
  const device = useDevice();
  let offsetHeight = (headerHeight - scrollPosition) / headerHeight;
  if (offsetHeight < 0) offsetHeight = 0;
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const newScrollPosition = window.scrollY;
          setScrollPosition(newScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <div
        id="navbarWrapper"
        className={clsx(
          styles.navWrapper,
          isHomePage && styles.home,
          isHidden && styles.hide,
          isTop && isHomePage && !device.mobile && styles.isTop,
        )}
        ref={navbarRef}
      >
        <style>{`:root{--logo-offset-height: ${offsetHeight}`}</style>
        {children}
      </div>
      {isHomePage && <div className={styles.spacingHome} />}
    </>
  );
};
export default NavbarWrap;
